import { useState } from "react";
import { SuspensedView } from "../../../Utils/AllHelperFunctions";
import AllCellCastUserList from "./AllCellCastUserList";
import Select from 'react-select'
import AllSmartSMSUserList from "../AllSmartSmsUser/AllSmartSMSUserList";

const viewOptions = [
  { value: 'cellcast', label: 'CellCast Users' },
  { value: 'smartsms', label: 'SmartSMS Users' },
];

const UserList = () => {
  const [view, setView] = useState<'cellcast' | 'smartsms'>('cellcast');

  return (
    <SuspensedView>
      <div className={'card'}>
        <div className='card-header border-0 p-0 align-items-center'>
          <div className='d-flex flex-column w-100'>
            <div className='d-flex justify-content-between align-items-center w-100'>
              <div className='col-md-6'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>User List</span>
                </h3>
              </div>
              <div className='d-flex align-items-center gap-4'>
                <Select
                  onChange={(e: any) => setView(e.value)}
                  options={viewOptions}
                  value={viewOptions.find((opt) => opt.value === view)}
                  className='min-w-200px'
                />
              </div>
            </div>
          </div>
        </div>

        {view === 'cellcast' && <AllCellCastUserList />}
        {view === 'smartsms' && <AllSmartSMSUserList />}
      </div>
    </SuspensedView>
  );
}

export default UserList;